import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

function EditActive() {
  const { mpi_id } = useParams();
  const navigate = useNavigate();
  const [view, setView] = useState();
  useEffect(() => {
    getPubDataView();
    console.log(view);
  }, []);

  const getPubDataView = async () => {
    try {
      const data = await axios.get(
        `${process.env.REACT_APP_NODE_URL}/admin/publisher/view/` + mpi_id
      );
      console.log(data.data.data, "setview");

      if (data.data.data !== undefined) setView(data.data.data);
    } catch (e) {
      console.log(e);
    }
  };

  const HandleFormData = (name, value, table) => {
    console.log('====================================');
    console.log(table,"table");
    console.log(name, value,"event");
    console.log('====================================');
    const fieldvalue = { ...view };
    fieldvalue[table][0][name] = value;
    setView(fieldvalue);
  };
  const ValidateFormData = (e) => {
    e.preventDefault();

    console.log(view);

    // convert array into object

    const updateData = {};
    Object.assign(updateData, view.portal_info[0]);
    Object.assign(updateData, view.pub_reg[0]);
    Object.assign(updateData, view.pub_basic[0]);
    Object.assign(updateData, view.pub_content[0]);
    Object.assign(updateData, view.pub_siteinfo[0]);
    Object.assign(updateData, view.pub_stats[0]);
    axios
      .put(
        `${process.env.REACT_APP_NODE_URL}/admin/publisher/update/` + mpi_id,
        updateData
      )
      .then(function (response) {
        if (response.status === 200) {
          navigate("/admin/publisher/active");
        }
        console.log(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  return (
    <>
      <div>
        <h1>Edit Active Publisher</h1>
      </div>
      {view !== undefined ? (
        <form onSubmit={ValidateFormData}>
          <div className="container-fluid-bg">
            <div className="row mt-3 mb-4">
              <div className="col-4">
                <label className="form-label float-start mb-2">Name</label>
                <input
                  className="form-control mb-3"
                  type="text"
                  readOnly="true"
                  name="name"
                  id="name"
                  defaultValue={
                    view !== undefined && view.pub_reg[0] !== undefined
                      ? view.pub_reg[0].firstname +
                        " " +
                        view.pub_reg[0].lastname
                      : ""
                  }
                  onChange={(event) => HandleFormData(event.target.name,event.target.value, "pub_reg")}
                  required
                />
                <label className="form-label float-start mb-2">
                  Domain Authority
                </label>
                <input
                  className="form-control mb-3"
                  type="text"
                  name="domain_authority"
                  id="domain_authority"
                  defaultValue={
                    view !== undefined && view.pub_basic[0] !== undefined
                      ? view.pub_basic[0].domain_authority
                      : ""
                  }
                  onChange={(event) => HandleFormData(event.target.name,event.target.value, "pub_basic")}
                  required
                />

                <label className="form-label float-start mb-2">
                  Publishing Speed
                </label>
                <input
                  className="form-control mb-3"
                  type="text"
                  name="publishing_speed"
                  id="publishing_speed"
                  defaultValue={
                    view !== undefined && view.pub_basic[0] !== undefined
                      ? view.pub_basic[0].publishing_speed
                      : ""
                  }
                  onChange={(event) => HandleFormData(event.target.name,event.target.value, "pub_basic")}
                  required
                />
                <label className="form-label float-start mb-2">Accept Link:</label>
                <input
                  className="form-control mb-3"
                  type="text"
                  name="accept_link
                      "
                  id="accept_link
                      "
                  defaultValue={
                    view !== undefined && view.pub_content[0] !== undefined
                      ? view.pub_content[0].accept_link
                      : ""
                  }
                  onChange={(event) => HandleFormData(event.target.name,event.target.value, "pub_content")}
                  required
                />
                <label className="form-label float-start mb-2">
                  Article Length:
                </label>
                <input
                  className="form-control mb-3"
                  type="text"
                  name="article_length"
                  id="article_length"
                  onInput={(event) => HandleFormData(event.target.name,event.target.value, "pub_content")}
                  defaultValue={
                    view !== undefined && view.pub_content[0] !== undefined
                      ? view.pub_content[0].article_length
                      : ""
                  }
                  required
                />
                <div className="float-start mt-4">
                  <input
                    type="checkbox"
                    className="me-3"
                    id="feature_site"
                    name="is_featured"
                    defaultChecked={view !== undefined && view.portal_info[0] !== undefined && view.portal_info[0].is_featured === 1 ? true : false}
                    onClick={(event) =>
                      event.target.checked
                        ? HandleFormData(event.target.name, 1, "portal_info")
                        : HandleFormData(event.target.name, 0, "portal_info")
                    }
                  />
                  <span>Featured sites</span>
                </div>
              </div>

              <div className="col-4">
                <label className="form-label float-start mb-2">Email</label>
                <input
                  className="form-control mb-3"
                  type="text"
                  readOnly="true"
                  name="email"
                  id="email"
                  defaultValue={
                    view !== undefined && view.pub_reg[0] !== undefined
                      ? view.pub_reg[0].email
                      : ""
                  }
                  onChange={(event) => HandleFormData(event.target.name,event.target.value, "pub_reg")}
                  required
                />
                <label className="form-label float-start mb-2">Do Follow</label>
                <input
                  className="form-control mb-3"
                  type="text"
                  name="doFollow"
                  id="doFollow"
                  onChange={(event) => HandleFormData(event.target.name,event.target.value, "pub_content")}
                  defaultValue={
                    view !== undefined && view.pub_content[0] !== undefined
                      ? view.pub_content[0].doFollow
                      : ""
                  }
                  required
                />
                <label className="form-label float-start mb-2">Image Count:</label>
                <input
                  className="form-control mb-3"
                  type="text"
                  name="image_count"
                  id="image_count"
                  onChange={(event) => HandleFormData(event.target.name,event.target.value, "pub_content")}
                  defaultValue={
                    view !== undefined && view.pub_content[0] !== undefined
                      ? view.pub_content[0].image_count
                      : ""
                  }
                  required
                />
                <label className="form-label float-start mb-2">No. of Days:</label>
                <input
                  className="form-control mb-3"
                  type="text"
                  name="no_of_days"
                  id="no_of_days"
                  onChange={(event) => HandleFormData(event.target.name,event.target.value, "pub_content")}
                  defaultValue={
                    view !== undefined && view.pub_content[0] !== undefined
                      ? view.pub_content[0].no_of_days
                      : ""
                  }
                  required
                />
                <label className="form-label float-start mb-2">
                  Number of Links:
                </label>
                <input
                  className="form-control mb-3"
                  type="text"
                  name="number_of_links
                  "
                  id="number_of_links
                  "
                  onChange={(event) => HandleFormData(event.target.name,event.target.value, "pub_content")}
                  defaultValue={
                    view !== undefined && view.pub_content[0] !== undefined
                      ? view.pub_content[0].number_of_links
                      : ""
                  }
                  required
                />
                <label className="form-label float-start mb-2">Post Tag:</label>
                <input
                  className="form-control mb-3"
                  type="text"
                  name="post_tag"
                  id="post_tag"
                  onInput={(event) => HandleFormData(event.target.name,event.target.value, "pub_content")}
                  defaultValue={
                    view !== undefined && view.pub_content[0] !== undefined
                      ? view.pub_content[0].post_tag
                      : ""
                  }
                  required
                />
              </div>
              <div className="col-4">
                <label className="form-label float-start mb-2">Tags:</label>
                <input
                  className="form-control mb-3"
                  type="text"
                  name="tags"
                  id="tags"
                  onInput={(event) => HandleFormData(event.target.name,event.target.value, "pub_siteinfo")}
                  defaultValue={
                    view !== undefined && view.pub_siteinfo[0] !== undefined
                      ? view.pub_siteinfo[0].tags
                      : ""
                  }
                  required
                />
                <label className="form-label float-start mb-2">Parent Topic:</label>
                <input
                  className="form-control mb-3"
                  type="text"
                  name="parent_topic"
                  id="parent_topic"
                  onInput={(event) => HandleFormData(event.target.name,event.target.value, "pub_siteinfo")}
                  defaultValue={
                    view !== undefined && view.pub_siteinfo[0] !== undefined
                      ? view.pub_siteinfo[0].parent_topic
                      : ""
                  }
                  required
                />
                <label className="form-label float-start mb-2">Description</label>
                <input
                  className="form-control mb-3"
                  type="text"
                  name="description"
                  id="description"
                  onChange={(event) => HandleFormData(event.target.name,event.target.value, "pub_siteinfo")}
                  defaultValue={
                    view !== undefined && view.pub_siteinfo[0] !== undefined
                      ? view.pub_siteinfo[0].description
                      : ""
                  }
                  required
                />
                <label className="form-label float-start mb-2">category:</label>
                <input
                  className="form-control mb-3"
                  type="text"
                  name="category"
                  id="category"
                  onChange={(event) => HandleFormData(event.target.name,event.target.value, "pub_siteinfo")}
                  defaultValue={
                    view !== undefined && view.pub_siteinfo[0] !== undefined
                      ? view.pub_siteinfo[0].category
                      : ""
                  }
                  required
                />
                {/* <label className="form-label float-start">
                Ahref
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="ahref"
                  id="ahref"
                  defaultValue={
                    view !== undefined && view.pub_basic[0] !== undefined
                      ? view.pub_basic[0].ahref
                      : ""
                  }
                  onChange={(event) => HandleFormData(event,"pub_basic")}
                  required
                /> */}
                <label className="form-label float-start mb-2">Trust Flow</label>
                <input
                  className="form-control mb-3"
                  type="text"
                  name="trust_flow"
                  id="trust_flow"
                  defaultValue={
                    view !== undefined && view.pub_basic[0] !== undefined
                      ? view.pub_basic[0].trust_flow
                      : ""
                  }
                  onChange={(event) => HandleFormData(event.target.name,event.target.value, "pub_basic")}
                  required
                />
                <label className="form-label float-start mb-2">Display Pages</label>
                <input
                  className="form-control mb-3"
                  type="text"
                  name="display_pages"
                  onInput={(event) => HandleFormData(event.target.name,event.target.value, "pub_content")}
                  id="display_pages"
                  defaultValue={
                    view !== undefined && view.pub_content[0] !== undefined
                      ? view.pub_content[0].display_pages
                      : ""
                  }
                  required
                />
              </div>
              <div className="mb-5">
              <button type="button" className="btn btn-md btn-danger mt-3 me-3">
              <Link to="/admin/publisher/active" className="text-white text-decoration-none">Back</Link>
            </button>
            <button type="submit" className="btn btn-md btn-primary mt-3">
              Update
            </button>
            </div>
            </div>        
          </div>
        </form>
      ) : (
        <p className="my-5">No Record Found</p>
      )}
    </>
  );
}

export default EditActive;
